/**
 * Lecturas remotas de informes sin dependencias de sales/catalog.
 */
export type { ReportsOperacionSource } from './domain/reportsTypes';
export {
  reportsQueryScopeHasFilters,
  type ReportsQueryScope,
} from './domain/reportsQueryScope';

export {
  fetchRemoteBranchCashSummary,
  fetchRemoteBranchCashSessions,
  fetchRemoteListSales,
  fetchRemotePosExceptionSummary,
  fetchRemoteSaleDetail,
  fetchRemoteSalesComparison,
  fetchRemoteSalesDaily,
  fetchRemoteSalesByCashier,
  fetchRemoteSalesSnapshot,
  fetchRemoteSalesTimeBands,
  fetchRemoteBranchSalesByProduct,
  fetchRemoteCashClosuresCount,
  fetchRemoteCashClosuresHistory,
  fetchRemoteCashActivity,
  fetchRemoteBranchStockMermaByProduct,
  isOnline,
} from './infra/reportsRemoteRepo';

export type { CashActivityItem, CashActivityKind } from './infra/reportsRemoteRepo';

export {
  fetchWithRetry,
  REMOTE_FETCH_RETRIES,
  REMOTE_FETCH_RETRY_DELAY_MS,
} from './infra/reportsRemoteRepo';

/** Cache compartido de lecturas remotas (invalidación cross-módulo). */
export {
  CASH_SUMMARY_REPORTS_CACHE_MS,
  getReportsCacheIfFresh,
  invalidateReportsCache,
  REPORTS_REMOTE_CACHE_MS,
  reportsCacheKey,
  setReportsCache,
  withReportsCache,
} from './infra/reportsRemoteCache';
